module.exports = __webpack_public_path__ + "static/img/67066G_7_8_R_20180610_fit.43272c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_7_8_R_20180610_fit.png
// module id = eFof
// module chunks = 0